import { createContext } from 'react'
import { MutateFunction } from 'react-query'
import {
  CatalogDataset,
  CatalogSubscription,
  CatalogSubscriptionRequestStatus,
  CatalogSubscriptionStatus,
  CatalogSubscriptionType
} from '../../types'

export type CatalogSubscriptionContext = {
  state: {
    cartoDWAccountProject?: string
    publicView: boolean
    actives?: CatalogSubscription[]
    requested?: string[]
    samples?: string[]
    isSubscriptionsLoading: boolean
    isSamplesLoading: boolean
  }
  actions: {
    navigateToDataExplorer: (dataset: CatalogDataset, subscriptionType: CatalogSubscriptionType) => void
    sendSampleAccessRequest: (dataset: CatalogDataset) => MutateFunction
    sendSubscriptionRequest: (dataset: CatalogDataset, status?: CatalogSubscriptionRequestStatus) => MutateFunction
    checkIfSubscriptionRequested: (dataset: CatalogDataset) => boolean
    checkIfSubscribed: (dataset: CatalogDataset) => boolean
    getSubscriptionStatus: (dataset: CatalogDataset) => CatalogSubscriptionStatus | null
    getSubscriptionExpirationLeft: (dataset: CatalogDataset) => number
    getSubscriptionExpiration: (dataset: CatalogDataset) => Date | null
  }
}

export enum CatalogSubscriptionActions {}

export type CatalogSubscriptionAction = {
  type: CatalogSubscriptionActions
  payload: CatalogSubscriptionContext['state'][keyof CatalogSubscriptionContext['state']]
}

const stub = (
  _payload: CatalogSubscriptionAction['payload'][keyof CatalogSubscriptionAction['payload']],
  // eslint-disable-next-line
  secondaryPayload?: any
): void | MutateFunction | boolean | string | CatalogSubscriptionStatus | number | null | Date => {
  throw new Error('You forgot to wrap your component in <FiltersProvider>.' + _payload + secondaryPayload)
}

export const SUBSCRIPTIONS_INITIAL_DATA = {
  state: {},
  actions: {
    navigateToDataExplorer: stub,
    sendSampleAccessRequest: stub,
    sendSubscriptionRequest: stub,
    checkIfSubscriptionRequested: stub,
    checkIfSubscribed: stub,
    getSubscriptionStatus: stub,
    getSubscriptionExpirationLeft: stub,
    getSubscriptionExpiration: stub
  }
}
export const CatalogSubscriptionDataContext = createContext(SUBSCRIPTIONS_INITIAL_DATA.state)
export const CatalogSubscriptionActionsContext = createContext(SUBSCRIPTIONS_INITIAL_DATA.actions)
